import React from 'react';
import {t} from "../../../i18n";

interface PickUpWorkPreviewBannerProps {
    /** 点「开始作业」：打点后解除只读 */
    onStartWork: () => void;
    /** 打点请求进行中，避免连点 */
    submitting?: boolean;
}

/**
 * 「仅查看今日任务」只读态的顶部横幅。
 *
 * 只读态下列表与地图都不响应点击，司机很容易以为 App 坏了——这条横幅是唯一的解释，
 * 也是唯一的开工入口，所以它必须常驻在列表顶部而不是一闪而过的 Toast。
 */
const PickUpWorkPreviewBanner: React.FC<PickUpWorkPreviewBannerProps> = ({onStartWork, submitting = false}) => {
    return (
        <div className="flex items-center gap-2 px-4 py-2.5" style={{background: '#FDF3E9'}}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" className="shrink-0">
                <circle cx="12" cy="12" r="10" stroke="#C9832E" strokeWidth="1.8"/>
                <line x1="12" y1="7" x2="12" y2="13" stroke="#C9832E" strokeWidth="1.8" strokeLinecap="round"/>
                <circle cx="12" cy="16.5" r="1.1" fill="#C9832E"/>
            </svg>
            <span className="flex-1 text-[13px]" style={{color: '#8A5A1E'}}>
                {t('pages.pickUp.startWork.previewTip')}
            </span>
            <span
                className={`text-[13px] font-semibold whitespace-nowrap ${submitting ? 'opacity-50' : ''}`}
                style={{color: 'var(--adm-color-primary)'}}
                onClick={submitting ? undefined : onStartWork}
            >
                {t('pages.pickUp.startWork.previewAction')}
            </span>
        </div>
    );
};

export default PickUpWorkPreviewBanner;
